
<div *ngIf="outcomeStatus" class="height-100per">
  <div class="flex-display height-100per">
    <div class="float-L width-77">
      <div class="left-scrollbar" id="searchPage">
        <div class="pl-5per search_padding_top">
          <div>
            <span class="searchtext flex-display" *ngIf="isElasticSearchTermAvailable">
              <span class="flex-display">
                Showing&nbsp;
                <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem" *ngIf="!isFullyLoaded"></mat-spinner>
                <span *ngIf="isFullyLoaded" class="">{{numberOfResult}}&nbsp;</span>
                results in {{category}} categories for
              </span>
              <!-- {{showingResults.toString().replace("[0]",numberOfResult).replace("[1]",category)}} -->
            </span>
            <span class="searchtext flex-display" *ngIf="!isElasticSearchTermAvailable">
              <span class="flex-display">
                {{searchtext}}
              </span>
            </span>
            <div class="flex-display">
              <div class="width-80 content-blue">
                <div class="search-container">
                  <input type="text" class="searchTopic search-top-heading" id="searchInput" value="{{elasticSearchCondition.Searchterm}}" (input)="handleInputChange()" (focus)="changeBool()" (keyup.enter)="sendSearch()" /><span class="clear-search" (click)="whenCross()"></span>
                </div>
              </div>
              <button mat-button class="btn-cancel-search" [class.active]="isButtonActive" (click)="sendSearch()" *ngIf="isElasticSearchTermAvailable">New Search</button>
              <button mat-button class="btn-cancel-search" [class.active]="isButtonActive" (click)="sendSearch()" *ngIf="!isElasticSearchTermAvailable">Search</button>
            </div>

            <div class="display-block">
              <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.ContentType.length > 0) && (activeTab === 'Codification')">in {{elasticSearchCondition.ContentType.join(', ')}} ContentTypes &nbsp;</span>
              <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.Section.length > 0) && (activeTab === 'Codification')">for {{elasticSearchCondition.Section.join(', ')}} Sections &nbsp;</span>
              <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.DocumentType.length > 0) && (activeTab === 'Original Pronouncements')">in {{elasticSearchCondition.DocumentType.join(', ')}} DocumentTypes &nbsp;</span>
              <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.Chapter.length > 0) && (activeTab === 'Comprehensive Implementation Guide')">in {{elasticSearchCondition.Chapter.join(', ')}} &nbsp;</span>
              <span class="search-bread-crumb" *ngIf="(elasticSearchCondition.CIGContentType.length > 0) && (activeTab === 'Comprehensive Implementation Guide')">in {{selectedCigFilters.join(', ')}} ContentTypes &nbsp;</span>
            </div>
          </div>
          <div *ngIf="isElasticSearchTermAvailable">
            <div class="glossaryTab">
              <div *ngFor="let glossaryTabs of searchTabHeading; let i = index">
                <!--<button class="tablinks bold" [ngClass]="(role=='Basic' && i==0?'width-30 active':(role == 'Basic' && i != 0 ? 'width-30':(role != 'Basic' && i == 0?'width-23 active':'width-23')))" (click)="searchContent($event, glossaryTabs.key)">-->
                <button class="tablinks bold" [ngClass]="{'active': activeTab === glossaryTabs.key,'width-30':role === 'Basic','width-23':role!=='Basic'}" (click)="searchContent($event, glossaryTabs.key)">
                  <span>
                    {{glossaryTabs.key}}&nbsp;
                    <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem inline-display" *ngIf="!isFullyLoaded && glossaryTabs.key!='Codification'"></mat-spinner>
                    <span *ngIf="glossaryTabs.key=='Codification'" class="lightGrey-color font-12 bold">({{glossaryTabs.docCount}})</span>
                    <span *ngIf="isFullyLoaded && glossaryTabs.key!='Codification'" class="lightGrey-color font-12 bold">({{glossaryTabs.docCount}})</span>
                  </span>
                </button>
              </div>
              <button *ngIf="role != 'Basic'" class="tablinks width-23 bold" [ngClass]="{ 'active': activeTab === 'otherTab'}" id="myButton" (click)="searchContent($event, 'other')">
                <span>
                  {{othersHeader}}&nbsp;
                  <span class="lightGrey-color font-12 bold">({{otherCount}})</span>
                  <mat-spinner strokeWidth="2" [diameter]="20" class="mr-0-5rem inline-display" *ngIf="!isFullyLoaded"></mat-spinner>
                </span>
              </button>
            </div>
            <div *ngIf="activeTab === 'Original Pronouncements'" class="mt-1rem">
              <div id="scrollList">
                <div class="searchResults" *ngFor="let op of OpSearchResult">
                  <div *ngIf="op.source.levelOne && op.source.levelTwo">
                    <div class="pt-1-25">
                      <div class="flex-display">
                        <div class="flex-display float-L width-100 flex-wrap">
                          <div class="searchTabText color-nav">
                            <span [innerHTML]="op.source.levelOne"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="op.source.levelTwo != null && op.source.levelTwo != '' && ((op.source.levelThree != null && op.source.levelThree != '') || ((op.source.levelThree == null || op.source.levelThree == '') && op.source.levelTwo != op.source.paraNumber && op.source.paraNumber != null && op.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="op.source.levelTwo"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="op.source.levelThree != null && op.source.levelThree != '' && ((op.source.levelFour != null && op.source.levelFour != '') ||((op.source.levelFour == null || op.source.levelFour == '') && op.source.levelThree != op.source.paraNumber && op.source.paraNumber != null && op.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="op.source.levelThree"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="op.source.levelFour != null && op.source.levelFour != '' && (( op.source.levelFive != null && op.source.levelFive != '') ||((op.source.levelFive == null || op.source.levelFive == '') && op.source.levelFour != op.source.paraNumber && op.source.paraNumber != null && op.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="op.source.levelFour"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="op.source.levelFive != null && op.source.levelFive != '' && op.source.levelFive != op.source.paraNumber && op.source.paraNumber != null && op.source.paraNumber != ''" class="searchTabText color-nav">
                            <span [innerHTML]="op.source.levelFive"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                    <a *ngIf="(op.source.paraNumber != null && op.source.paraNumber != '' && ((op.source.levelFive != '' && op.source.levelFive != null && op.source.levelFive != op.source.paraNumber) || ((op.source.levelFive == null || op.source.levelFive == '') && (op.source.levelFour != '' && op.source.levelFour != null && op.source.levelFour != op.source.paraNumber)) || ((op.source.levelFour == null || op.source.levelFour == '') && (op.source.levelThree != '' && op.source.levelThree != null && op.source.levelThree != op.source.paraNumber))));else op_levelFive" (contextmenu)="onRightClick($event,op.source)" (mouseover)="mouseOverFunctions($event,op.source)" (click)="openLinkById(op.source)"
                       class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                      <span *ngIf="op.source.paraNumber && op.source.paraType=='FOOTNOTE'">fn</span>
                      <span *ngIf="op.source.paraNumber" [innerHTML]="op.source.paraNumber"></span>
                    </a>
                    <ng-template #op_levelFive>
                      <a *ngIf="(op.source.levelFive != null && op.source.levelFive != '');else op_levelFour" (contextmenu)="onRightClick($event,op.source)" (mouseover)="mouseOverFunctions($event,op.source)" (click)="openLinkById(op.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span *ngIf="op.source.levelFive" [innerHTML]="op.source.levelFive"></span>
                      </a>
                    </ng-template>
                    <ng-template #op_levelFour>
                      <a *ngIf="(op.source.levelFour != null && op.source.levelFour != '');else op_levelThree" (contextmenu)="onRightClick($event,op.source)" (mouseover)="mouseOverFunctions($event,op.source)" (click)="openLinkById(op.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span *ngIf="op.source.levelFour != ''" [innerHTML]="op.source.levelFour"></span>
                      </a>
                    </ng-template>

                    <ng-template #op_levelThree>
                      <a *ngIf="(op.source.levelThree != null && op.source.levelThree != '');else op_levelTwo" (contextmenu)="onRightClick($event,op.source)" (mouseover)="mouseOverFunctions($event,op.source)" (click)="openLinkById(op.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span *ngIf="op.source.levelThree != ''" [innerHTML]="op.source.levelThree"></span>
                      </a>
                    </ng-template>
                    <ng-template #op_levelTwo>
                      <a *ngIf="(op.source.levelTwo != null && op.source.levelTwo != '')" (contextmenu)="onRightClick($event,op.source)" (mouseover)="mouseOverFunctions($event,op.source)" (click)="openLinkById(op.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span *ngIf="op.source.levelTwo != ''" [innerHTML]="op.source.levelTwo"></span>
                      </a>
                    </ng-template>

                    <div class="ml-2 mt-1rem" [innerHTML]="op.source.body">
                    </div>
                  </div>
                </div>

                <div class="searchResults" *ngFor="let contact of opGlossaryResult">
                  <div class="flex-display pt-1-25">
                    <div>
                      <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="History">
                    </div>
                    <div>&nbsp;&nbsp;</div>
                    <div class="flex-display flex-direction-column searchGlossary">
                      <span class="font-18 searchGlossaryHeader"
                            [innerHTML]="contact.formattedGlossaryTitle" (click)="OpenGlossaryLink($event,contact.name)"></span>
                      <p class="ml-32px glossary-p">
                        <span class="font-14 highlight-blue border-bottom-help cursor-pointer right-Overlay" id="glossary-term-usage"
                              *ngIf="contact.topic.length > 0" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                        <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                      </p>
                      <span class="mat-Info" (contextmenu)="onGlossaryRightClick($event)" (mouseover)="glossaryMouseOverFunctions($event)" (click)="OpenGlossaryLink($event,contact.name)"
                            [innerHTML]="contact.capital"></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="OpTabResultCount==0">
                  <div class="pb-16 pendingheading font-24 ">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                </div>
              </div>
              <div [ngClass]="(OpTabResultCount>OpResultCount)?'align-item-single-line':'pr-1rem'">
                <div class="mt-4 width-65" *ngIf="(OpTabResultCount>OpResultCount)">
                  <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_op')">
                    Load
                    more
                  </button>
                </div>
                <div class="links cursor-pointer flex-display pl-13rem float-R text-decoration-none" (click)="setFocus()"
                     *ngIf="enableBackToTop && OpResultCount!=0">
                  <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
                  <span>
                    <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
                  </span>
                </div>
              </div>

            </div>
            <div *ngIf="activeTab === 'Codification'" class="mt-1rem">
              <div id="scrollList">
                <div class="searchResults" *ngFor="let cod of CodSearchResult">
                  <div *ngIf="cod.source.levelOne != null  && cod.source.levelTwo != null">
                    <div class="pt-1-25">
                      <div class="flex-display">
                        <div class="flex-display float-L width-100 flex-wrap">
                          <div class="searchTabText color-nav">
                            <span [innerHTML]="cod.source.levelOne"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="cod.source.levelTwo != null && cod.source.levelTwo != '' && ((cod.source.levelThree != null && cod.source.levelThree != '') || ((cod.source.levelThree == null || cod.source.levelThree == '') && cod.source.paraNumber != null && cod.source.paraNumber != '' && cod.source.levelTwo!=cod.source.paraNumber))" class="searchTabText color-nav">
                            <span [innerHTML]="cod.source.levelTwo"></span>&nbsp;
                            <img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="cod.source.levelThree != null && cod.source.levelThree != '' && ((cod.source.levelFour != null && cod.source.levelFour != '') || ((cod.source.levelFour == null || cod.source.levelFour == '') && cod.source.paraNumber != null && cod.source.paraNumber != '' && cod.source.levelThree!=cod.source.paraNumber))" class="searchTabText color-nav">
                            <span [innerHTML]="cod.source.levelThree"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="cod.source.levelFour != null && cod.source.levelFour != '' && ((cod.source.levelFive != null && cod.source.levelFive != '') || ((cod.source.levelFive == null || cod.source.levelFive == '') && cod.source.paraNumber != null && cod.source.paraNumber != '' && cod.source.levelFour!=cod.source.paraNumber))" class="searchTabText color-nav">
                            <span [innerHTML]="cod.source.levelFour"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>

                          <div *ngIf="cod.source.levelFive != null && cod.source.levelFive != '' && cod.source.paraNumber != null && cod.source.paraNumber != '' && cod.source.levelFive!=cod.source.paraNumber" class="searchTabText color-nav">
                            <span [innerHTML]="cod.source.levelFive"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                        </div>
                      </div>

                    </div>

                    <a *ngIf="(cod.source.paraNumber != null && cod.source.paraNumber != '' && ((cod.source.levelFive != '' && cod.source.levelFive != null && cod.source.levelFive != cod.source.paraNumber) || ((cod.source.levelFive == null || cod.source.levelFive == '') && (cod.source.levelFour != '' && cod.source.levelFour != null && cod.source.levelFour != cod.source.paraNumber)) || ((cod.source.levelFour == null || cod.source.levelFour == '') && (cod.source.levelThree != '' && cod.source.levelThree != null && cod.source.levelThree != cod.source.paraNumber))));else cod_levelFive" class="searchTabText pdf-link font-20 color-heading ptb-1-25" (contextmenu)="onRightClick($event,cod.source)" (mouseover)="mouseOverFunctions($event,cod.source)" (click)="openLinkById(cod.source)">
                      <span *ngIf="cod.source.paraNumber && cod.source.paraType=='FOOTNOTE'">fn</span>
                      <span *ngIf="cod.source.paraNumber" [innerHTML]="cod.source.paraNumber"></span>
                    </a>
                    <ng-template #cod_levelFive>
                      <a *ngIf="(cod.source.levelFive != null && cod.source.levelFive != '');else cod_levelFour" class="searchTabText pdf-link font-20 color-heading ptb-1-25" (contextmenu)="onRightClick($event,cod.source)" (mouseover)="mouseOverFunctions($event,cod.source)" (click)="openLinkById(cod.source)">
                        <span *ngIf="cod.source.levelFive" [innerHTML]="cod.source.levelFive"></span>
                      </a>
                    </ng-template>
                    <ng-template #cod_levelFour>
                      <a *ngIf="(cod.source.levelFour != null && cod.source.levelFour != '');else cod_levelThree" class="searchTabText pdf-link font-20 color-heading ptb-1-25" (contextmenu)="onRightClick($event,cod.source)" (mouseover)="mouseOverFunctions($event,cod.source)" (click)="openLinkById(cod.source)">
                        <span *ngIf="cod.source.levelFour" [innerHTML]="cod.source.levelFour"></span>
                      </a>
                    </ng-template>

                    <ng-template #cod_levelThree>
                      <a *ngIf="(cod.source.levelThree != null && cod.source.levelThree != '');else cod_levelTwo" class="searchTabText pdf-link font-20 color-heading ptb-1-25" (contextmenu)="onRightClick($event,cod.source)" (mouseover)="mouseOverFunctions($event,cod.source)" (click)="openLinkById(cod.source)">
                        <span *ngIf="cod.source.levelThree" [innerHTML]="cod.source.levelThree"></span>&nbsp;
                      </a>
                    </ng-template>

                    <ng-template #cod_levelTwo>
                      <a *ngIf="(cod.source.levelTwo != null && cod.source.levelTwo != '')" class="searchTabText pdf-link font-20 color-heading ptb-1-25" (contextmenu)="onRightClick($event,cod.source)" (mouseover)="mouseOverFunctions($event,cod.source)" (click)="openLinkById(cod.source)">
                        <span *ngIf="cod.source.levelTwo" [innerHTML]="cod.source.levelTwo"></span>&nbsp;
                      </a>
                    </ng-template>
                    <div class="ml-2 mt-1rem" [innerHTML]="cod.source.body">
                    </div>
                  </div>
                </div>

                <div class="searchResults" *ngFor="let contact of codGlossaryResult">
                  <div class="flex-display pt-1-25">
                    <div>
                      <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="History">
                    </div>
                    <div>&nbsp;&nbsp;</div>
                    <div class="flex-display flex-direction-column searchGlossary">
                      <span class="font-18 searchGlossaryHeader"
                            [innerHTML]="contact.formattedGlossaryTitle" (click)="OpenGlossaryLink($event,contact.name)"></span>
                      <p class="ml-32px glossary-p">
                        <span class="font-14 highlight-blue border-bottom-help cursor-pointer right-Overlay" id="glossary-term-usage"
                              *ngIf="contact.topic.length > 0" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                        <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                        <div class="mat-Info" (contextmenu)="onGlossaryRightClick($event)" (mouseover)="glossaryMouseOverFunctions($event)" (click)="OpenGlossaryLink($event,contact.name)"
                             [innerHTML]="contact.capital"></div>
                    </div>
                  </div>
                </div>

                <div *ngIf="CodTabResultCount==0">
                  <div class="pb-16 pendingheading font-24 ">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                </div>
              </div>

              <div [ngClass]="(CodTabResultCount>CodResultCount)?'align-item-single-line':'pr-1rem'">
                <div class="mt-4 width-65" *ngIf="(CodTabResultCount>CodResultCount)">
                  <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_codification')">
                    Load
                    more
                  </button>
                </div>
                <div class="links cursor-pointer flex-display pl-13rem float-R text-decoration-none" (click)="setFocus()"
                     *ngIf="enableBackToTop && CodResultCount!=0">
                  <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
                  <span>
                    <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="activeTab === 'otherTab'" class="mt-1rem">
              <div id="scrollList">
                <div *ngFor="let result of annotationResult">
                  <div class="pt-1-25">
                    <div class="flex-display">
                      <div>
                        <img src="../../../assets/icons/pencil-alt.svg" class="history-type-images" alt="Annotation">
                      </div>
                      <div>&nbsp;&nbsp;</div>
                      <div>
                        <span class="font-18 highlight-blue border-bottom-help cursor-pointer" (click)="redirectToAnnotationUrl(result)"
                              [innerHTML]="result.annotationTitle"></span><br />
                        <p class="history-breadcrumb mt-8px glossary-p">{{result.createdOn.split(" ")[0] | date:'longDate'}}</p>
                        <span class="mat-Info mt-8px" [innerHTML]="result.annotationDescription"></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngFor="let result of bookmarkResult">
                  <div class="pt-1-25">
                    <div class="flex-display">
                      <div>
                        <img src="../../../assets/icons/Bookmark.svg" class="history-type-images" alt="Bookmark">
                      </div>
                      <div>&nbsp;&nbsp;</div>
                      <div>
                        <span class="font-18 itcBookFont"
                              [innerHTML]="result.bookmarkTitle | highlightSearchTerm : elasticSearchCondition.Searchterm"></span><br />
                        <div class="flex-display history-breadcrumb">
                          <div *ngFor="let breadcrumbParts of result.bookMarkBreadCrumb.toString().split('~')">
                            <div *ngIf="breadcrumbParts != result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-1]"
                                 class="flex-display font-14">
                              {{breadcrumbParts}}
                              <span *ngIf="breadcrumbParts != result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-2]">
                                <img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow"
                                     src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right">
                              </span>
                              <span *ngIf="breadcrumbParts == result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-2]">
                                <img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow"
                                     src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right">
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="flex-display mt-4px">
                          <span class="font-18 highlight-blue border-bottom-help cursor-pointer" (click)="redirectToBookmarkUrl(result)" [innerHTML]="result.bookMarkBreadCrumb.toString().split('~')[result.bookMarkBreadCrumb.toString().split('~').length-1].split('____')[0]">

                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                  <div *ngIf="otherCount==0">
                    <div class="pb-16 pendingheading font-24 ">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                  </div>
                </div>
            </div>
            <div *ngIf="activeTab === 'Comprehensive Implementation Guide'" class="mt-1rem">
              <div id="scrollList">
                <div class="searchResults" *ngFor="let cig of CigSearchResult">
                  <div *ngIf="cig.source.levelOne && cig.source.levelTwo">
                    <div class="pt-1-25">
                      <div class="flex-display">
                        <div class="flex-display float-L width-100 flex-wrap">
                          <div *ngIf="cig.source.levelOne != null && cig.source.levelOne != ''" class="searchTabText color-nav">
                            <span [innerHTML]="cig.source.levelOne"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>

                          <div *ngIf="cig.source.levelTwo != null && cig.source.levelTwo != '' && ((cig.source.levelThree  != null && cig.source.levelThree  != '') || ((cig.source.levelThree == null || cig.source.levelThree == '') && cig.source.levelTwo != cig.source.paraNumber && cig.source.paraNumber != null && cig.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="cig.source.levelTwo"></span>
                            <img *ngIf="cig.source.levelThree != null" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg"
                                 class="arrow whatsNew-image">&nbsp;
                          </div>

                          <div *ngIf="cig.source.levelThree != null && cig.source.levelThree != '' && ((cig.source.levelFour != null && cig.source.levelFour != '') || ((cig.source.levelFour == null || cig.source.levelFour == '') && cig.source.levelThree != cig.source.paraNumber && cig.source.paraNumber != null && cig.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="cig.source.levelThree"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="cig.source.levelFour != null && cig.source.levelFour != '' && ((cig.source.levelFive != null  && cig.source.levelFive != '') || ((cig.source.levelFive == null  || cig.source.levelFive == '') && cig.source.levelFour != cig.source.paraNumber && cig.source.paraNumber != null && cig.source.paraNumber != ''))" class="searchTabText color-nav">
                            <span [innerHTML]="cig.source.levelFour"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                          <div *ngIf="cig.source.levelFive != null && cig.source.levelFive != '' && cig.source.levelFive != cig.source.paraNumber && cig.source.paraNumber != null && cig.source.paraNumber != ''" class="searchTabText color-nav">
                            <span [innerHTML]="cig.source.levelFive"></span>&nbsp;<img alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                    <a *ngIf="(cig.source.paraNumber != null && cig.source.paraNumber != '' && ((cig.source.levelFive != '' && cig.source.levelFive != null && cig.source.levelFive != cig.source.paraNumber) || ((cig.source.levelFive == null || cig.source.levelFive == '') && (cig.source.levelFour != '' && cig.source.levelFour != null && cig.source.levelFour != cig.source.paraNumber)) || ((cig.source.levelFour == null || cig.source.levelFour == '') && (cig.source.levelThree != '' && cig.source.levelThree != null && cig.source.levelThree != cig.source.paraNumber))));else cig_levelFive" (contextmenu)="onRightClick($event,cig.source)" (mouseover)="mouseOverFunctions($event,cig.source)" (click)="openLinkById(cig.source)"
                       class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                      <span *ngIf="cig.source.paraNumber && cig.source.paraType=='FOOTNOTE'">fn</span>
                      <span [innerHTML]="cig.source.paraNumber"></span>
                    </a>
                    <ng-template #cig_levelFive>
                      <a *ngIf="(cig.source.levelFive != null && cig.source.levelFive != '');else cig_levelFour" (contextmenu)="onRightClick($event,cig.source)" (mouseover)="mouseOverFunctions($event,cig.source)" (click)="openLinkById(cig.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span [innerHTML]="cig.source.levelFive"></span>
                      </a>
                    </ng-template>
                    <ng-template #cig_levelFour>
                      <a *ngIf="(cig.source.levelFour != null && cig.source.levelFour != '');else cig_levelThree" (contextmenu)="onRightClick($event,cig.source)" (mouseover)="mouseOverFunctions($event,cig.source)" (click)="openLinkById(cig.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span [innerHTML]="cig.source.levelFour"></span>
                      </a>
                    </ng-template>

                    <ng-template #cig_levelThree>
                      <a *ngIf="(cig.source.levelThree != null && cig.source.levelThree != '');else cig_levelTwo" (contextmenu)="onRightClick($event,cig.source)" (mouseover)="mouseOverFunctions($event,cig.source)" (click)="openLinkById(cig.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span [innerHTML]="cig.source.levelThree"></span>
                      </a>
                    </ng-template>
                    <ng-template #cig_levelTwo>
                      <a *ngIf="(cig.source.levelTwo != null && cig.source.levelTwo != '')" (contextmenu)="onRightClick($event,cig.source)" (mouseover)="mouseOverFunctions($event,cig.source)" (click)="openLinkById(cig.source)"
                         class="searchTabText pdf-link font-20 color-heading ptb-1-25">
                        <span [innerHTML]="cig.source.levelTwo"></span>
                      </a>
                    </ng-template>
                    <div class="ml-2 mt-1rem" [innerHTML]="cig.source.body">
                    </div>
                  </div>
                </div>

                <div class="searchResults" *ngFor="let contact of cigGlossaryResult">
                  <div class="flex-display pt-1-25">
                    <div>
                      <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="History">
                    </div>
                    <div>&nbsp;&nbsp;</div>
                    <div class="flex-display flex-direction-column searchGlossary">
                      <span class="font-18 searchGlossaryHeader"
                            [innerHTML]="contact.formattedGlossaryTitle" (click)="OpenGlossaryLink($event,contact.name)"></span>
                      <p class="ml-32px glossary-p">
                        <span class="font-14 highlight-blue border-bottom-help cursor-pointer right-Overlay" id="glossary-term-usage"
                              *ngIf="contact.topic.length > 0" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                        <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                      </p>
                      <span class="mat-Info" (contextmenu)="onGlossaryRightClick($event)" (mouseover)="glossaryMouseOverFunctions($event)" (click)="OpenGlossaryLink($event,contact.name)"
                            [innerHTML]="contact.capital"></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="CigTabResultCount==0">
                  <div class="pb-16 pendingheading font-24 ">{{NoResults}} "{{elasticSearchCondition.Searchterm}}"</div>
                </div>
              </div>

              <div [ngClass]="CigTabResultCount>CigResultCount?'align-item-single-line':'pr-1rem'">
                <div class="mt-4 width-65" *ngIf="(CigTabResultCount>CigResultCount)">
                  <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_cig')">Load more</button>
                </div>
                <div class="links cursor-pointer flex-display pl-13rem float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && CigResultCount!=0">
                  <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
                  <span>
                    <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="alRight float-R scrollbar">
      <div class="padding-right-pc-search">
        <div *ngIf="activeTab === 'Codification' && (contentTypeResult.length>0)" class="width-90">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{contentType}}</div>

          <div class="pl-8px" *ngFor="let type of contentTypeResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu text-transform-capitalize" [disabled]="isFilterLocked" [checked]="type.checked" [value]="type.key" (change)="checkedContentType($event)">{{type.key}}&nbsp;({{type.docCount}})</mat-checkbox>
          </div>
        </div>
        <div *ngIf="activeTab === 'Codification' && (sectionsResult.length>0)">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{NarrowResultsBySection}}</div>
          <div class="flex-display pt-10">
            <mat-form-field class="width-27 ml-0-5" appHostListenerClick>
              <mat-label>{{section}}</mat-label>
              <mat-select [disabled]="isDropdownLocked" [formControl]="sections" ngModel>
                <mat-option *ngFor="let section of sectionsResult" [value]="section.key">
                  {{section.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="pl-1-25">
              <button mat-button [ngClass]="sections.value!=''? 'btn-secondary-action-close':'btn-secondary-action-reset'" [disabled]="sections.value==''" type="reset" (click)="selectedSection()">{{addbutton}}</button>
            </div>
          </div>
          <span [ngStyle]="{'color':'#78797B'}">
            {{sectionText}}
          </span>
        </div>
        <div *ngIf="SelectedSection.length>0 && activeTab === 'Codification'" class="mt-1rem flex-display flex-wrap">
          <span class="padding-0-5 bg-color-faf-blue mr-1rem mb-1 cursor-pointer" *ngFor="let sec of SelectedSection">
            <span class="font-white">{{sec}}</span>
            <img alt="close icon" src="../../../assets/icons/temp/close-white.svg" (click)="RemoveSection(sec)" (keyup.enter)="RemoveSection(sec)"
                 class="close-btn pl-8px">
          </span>
        </div>

        <div *ngIf="activeTab === 'otherTab' && role != 'Basic'">
          <div *ngIf="(annotationCount > 0 || bookmarkCount > 0) && category > 0">
            <div class="answer content-blue width-100 bold right-overlay-heading"> {{contentType}}</div>

            <div *ngIf="annotationCount > 0 && category > 0">
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="AnnotationChecked" [value]="MyAnnotations" (change)="checkedOtherContentType($event)">My annotations</mat-checkbox>
            </div>
            <div *ngIf="bookmarkCount > 0 && category > 0">
              <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="BookmarkChecked" [value]="MyBookmarks" (change)="checkedOtherContentType($event)">My bookmarks</mat-checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="activeTab === 'Original Pronouncements' && (documentTypeResult.length>0)" class="pt-1">
          <span [ngStyle]="{'color':'#78797B'}">
            {{opFiltertext}}
          </span>
        </div>
        <div *ngIf="activeTab === 'Original Pronouncements' && (documentTypeResult.length>0)" class="width-90">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{NarrowResultsByDocumentType}}</div>

          <div class="pl-8px" *ngFor="let docType of documentTypeResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="docType.checked" [value]="docType.key" (change)="checkedDocumentType($event)">
              {{docType.key}}&nbsp;({{docType.docCount}})
            </mat-checkbox>
          </div>
        </div>

        <div *ngIf="activeTab === 'Original Pronouncements' && (pronouncementNumbersResult.length>0)">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">Narrow Results By Pronouncement:</div>
          <div class="flex-display pt-10">
            <mat-form-field class="width-27 ml-0-5" appHostListenerClick>
              <mat-label>Pronouncement</mat-label>
              <mat-select [disabled]="isDropdownLocked" [formControl]="pronouncementNumber" ngModel>
                <mat-option *ngFor="let pro_number of pronouncementNumbersResult" [value]="pro_number.key">
                  {{pro_number.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="pl-1-25">
              <button mat-button [ngClass]="pronouncementNumber.value!=''? 'btn-secondary-action-close':'btn-secondary-action-reset'" [disabled]="pronouncementNumber.value==''" type="reset" (click)="SelectedPronouncementNumber()">{{addbutton}}</button>
            </div>
          </div>
          <span [ngStyle]="{'color':'#78797B'}">
            {{sectionText}}
          </span>
        </div>
        <div *ngIf="SelectedPronouncement.length>0 && activeTab === 'Original Pronouncements'" class="mt-1rem flex-display flex-wrap">
          <span class="padding-0-5 bg-color-faf-blue mr-1rem mb-1 cursor-pointer" *ngFor="let pro of SelectedPronouncement">
            <span class="font-white">{{pro}}</span>
            <img alt="close icon" src="../../../assets/icons/temp/close-white.svg" (click)="RemovePronouncement(pro)" (keyup.enter)="RemovePronouncement(pro)"
                 class="close-btn pl-8px">
          </span>
        </div>

        <div *ngIf="activeTab === 'Comprehensive Implementation Guide' && (chapterResult.length>0 || totalCigGlossaryCount>0)" class="width-90">
          <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{NarrowResultsByChapter}}</div>

          <div class="pl-8px" *ngFor="let chapter of chapterResult">
            <mat-checkbox color="primary" class="pt-10 right-overlay-menu" [disabled]="isFilterLocked" [checked]="selectedChapter.indexOf(chapter.key) !== -1" [value]="chapter.key" (change)="checkedChapter($event)" [title]="chapter.chapterTitle">
              {{chapter.key}}&nbsp;({{chapter.docCount}})
            </mat-checkbox>
          </div>
          <div>
            <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{NarrowResultByContentType}}</div>
            <div class="flex-display pt-10">
              <mat-form-field class="width-27 ml-0-5" appHostListenerClick>
                <mat-label>Filter</mat-label>
                <mat-select [(ngModel)]="selectedType" [formControl]="selectedFilterControl">
                  <div *ngFor="let filter of cigContentTypeResult">
                    <mat-option value="{{filter.key}}">{{filter.key}}</mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
              <div class="pl-1-25">
                <button mat-button [ngClass]="selectedFilterControl.value!=''? 'btn-secondary-action-close':'btn-secondary-action-reset'" [disabled]="selectedFilterControl.value==''" type="reset" (click)="onFilterSelectionChanged(selectedType)">{{addbutton}}</button>
              </div>
            </div>
            <span [ngStyle]="{'color':'#78797B'}">
              {{sectionText}}
            </span>
          </div>
          <div *ngIf="selectedCigFilters.length>0 && activeTab === 'Comprehensive Implementation Guide'" class="mt-1rem flex-display flex-wrap">
            <span class="padding-0-5 bg-color-faf-blue mr-1rem mb-1 cursor-pointer" *ngFor="let filter of selectedCigFilters">
              <span class="font-white">{{filter}}</span>
              <img alt="close icon" src="../../../assets/icons/temp/close-white.svg" (click)="onFilterSelectionRemoved(filter)" (keyup.enter)="onFilterSelectionRemoved(filter)"
                   class="close-btn pl-8px">
            </span>
          </div>

        </div>

          <div>
          </div>

          <div *ngIf="role != 'Basic'">
            <div class="pt-1-25 answer content-blue width-100 bold right-overlay-heading">{{recent}}</div>
            <div *ngFor="let term of recentSearchTerm" class="mt-8px"><span class="font-14 highlight-blue border-bottom-help cursor-pointer" (click)="searchNewTerm(term.searchKeyword)">{{term.searchKeyword}}</span> </div>
          </div>
        </div>
    </div>
  </div>
</div>

